import { Avatar, Button, css } from '@mui/material'
import { styled } from '@mui/material/styles'
import { colors } from '@theme/variables'

export const SectionsListWrapper = styled('div')`
  width: 100%;
  height: 100%;
  overflow-y: auto;
  border-radius: 4px;
  border: 1px solid ${colors.lightGrey};
  background: ${colors.white};
  padding: 20px;
`

export const ViewMoreSection = styled('div')`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const SectionWrapper = styled('div')`
  width: 100%;
  margin-bottom: 32px;
`

export const SectionTitle = styled('div')`
  color: ${colors.black};
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 10px;
`

export const SectionContent = styled('div')`
  width: 100%;
  padding: 16px;
  border-radius: 8px;
  border: 1px solid #e7eff3;
  background: #f2f8fb;
  display: flex;
  flex-wrap: wrap;
  gap: 13px;
  align-items: center;
`

export const LoaderContainer = styled('div')`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const DelegateCardWrapper = styled('div')`
  width: 166px;
  height: 176px;
  padding: 16px 16px 12px;
  border-radius: 8px;
  border: 1px solid ${colors.lightGrey2};
  background: ${colors.white};
  box-shadow: 0px 1px 4px 0px rgba(26, 26, 67, 0.1);
`

export const CardTopSection = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 9px;
`

export const CardAvatar = styled(Avatar)`
  width: 60px;
  height: 60px;
`

export const CardContactButton = styled(Button)`
  min-width: 0;
  padding: 0;
  margin-right: 1px;
  align-items: flex-start;
`

export const DelegateCardTitle = styled('div')`
  color: ${colors.primary};
  font-size: 16px;
  font-weight: 500;
  word-break: break-all;

  ${(props: { isLong?: boolean }) =>
    props.isLong
      ? css`
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        `
      : ''}
`

export const DelegateCardSubtitle = styled('div')`
  color: ${colors.bodyText};
  font-size: 14px;
  word-break: break-all;

  ${(props: { isLong?: boolean }) =>
    props.isLong
      ? css`
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        `
      : ''}
`

export const DelegateCardIconsContainer = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 5px;
`
